import { Col, Row } from "react-bootstrap";
import { StageIcon } from "../icons/StageIcon";
import { TimeIcon } from "../icons/TimeIcon";
import { LabelIcon } from "../icons/LabelIcon";
import { ParticipantIcon } from "../icons/ParticipantIcon";
import { SubtaskIcon } from "../icons";
import { EditIcon } from "../icons/EditIcon";
import { useCardListHeaderHook } from "./useCardListHeaderHook";
import { useCallback, useContext } from "react";
import { WorkspaceShowContext } from "../../contexts/WorkspaceShowContext";
import { useDispatch, useSelector } from "react-redux";

const CardListHeader = ({
    scrollRef = null
}) => {
    const {
        stickyRef,
        currentStage,
    } = useCardListHeaderHook({
        initialStage: 'Stage 1',
        scrollRef: scrollRef
    });
    const {  
        can_access_show_content_details 
    } = useSelector(state => state.work_space);
    const dispatch = useDispatch();

    const renderTitle = useCallback(() => {
        if (currentStage) {
            return (
                <h2 className="h4 mb-0 w-100 p-0" style={{ maxWidth: "fit-content" }}>
                    {currentStage?.name}
                </h2>
            );
        } else {
            return null
        }
    }, [currentStage]);

    return (
        <div 
            className="card-list-header d-flex align-items-center"
            ref={stickyRef}
        >
            <table className="content-group-table table responsive-table content-list-table row-hoverable mb-0 header-table">
                <thead>
                    <tr>
                    <th
                        style={{width: 530}} scope="col"
                        className='content-group-table__title'
                    >
                        {renderTitle(currentStage)}
                    </th>
                    <th
                        style={{width: 170}}
                        className="content-group-table__stage text-center">
                            <div className="d-flex align-items-center w-100 justify-content-center">
                                <StageIcon color="#727580" height={16} width={16} className="me-1" />
                                Stage
                            </div>
                            
                    </th>
                    <th
                        style={{width: 170}}
                        className="content-group-table__due-date text-center">
                            <div className="d-flex align-items-center w-100 justify-content-center">
                                <TimeIcon color="#727580" height={16} width={16} className="me-1" />
                                Due Date
                            </div>
                    </th>
                    <th
                        style={{width: 170}}
                        className="content-group-table__label text-center">
                            <div className="d-flex align-items-center w-100 justify-content-center">
                                <LabelIcon color="#727580" height={16} width={16} className="me-1" />
                                Labels
                            </div>
                    </th>
                    {
                        can_access_show_content_details &&
                        <th
                            style={{width: 170}}
                            scope="col"
                            className="content-group-table__participants text-center">
                                <div className="d-flex align-items-center w-100 justify-content-center">
                                    <ParticipantIcon color="#727580" height={12} width={12} className="me-1" />
                                    Participants
                                </div>
                        </th>
                    }

                    <th
                        className=" content-group-table__title text-center subtask-cell">
                            <div className="d-flex align-items-center w-100 justify-content-center">
                                <SubtaskIcon color="#727580" height={16} width={16} />
                            </div>
                    </th>

                    <th
                        className="content-group-table__title text-center timer-cell">
                            <div className="d-flex align-items-center w-100 justify-content-center">
                                <TimeIcon color="#727580" height={16} width={16} />
                            </div>
                    </th>

                    <th
                        className="content-group-table__title text-center revision-cell">
                            <div className="d-flex align-items-center w-100 justify-content-center">
                                <EditIcon color="#727580" height={12} width={12} />
                            </div>
                    </th>
                    </tr>
                </thead>
            </table>
        </div>

    )
};

export { CardListHeader };